import React, { useEffect } from 'react';

import PageHeader from '../components/page-header';
import WarningInformation from '../components/warning-information';
import { selectWalletAddress } from '../redux/walletSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderItemAmount } from '../redux/orderItemAmountSlice';
import { OpenTxid, PaymentTxid, UserDeadline } from '../constants/localStorageKeys';
import { setSession } from '../redux/sessionSlice';
import { showToastError } from '../components/toastNotification';
import { BackendApi, Socket } from './router-page';

const QueuePage = ({ handleGoShippingInfo, handleGoQuiz, }) => {

  const dispatch = useDispatch();
  const orderItemCount = useSelector(selectOrderItemAmount);
  const walletAddress = useSelector(selectWalletAddress);

  const RetryCreateContract = async () => {
    try {
      const response = await BackendApi.post(
        `/script/open`,
        {
          walletAddress: walletAddress,
          amount: orderItemCount
        }
      );
  
      if (response.data.success) {
        if (response.data.data.session)
          dispatch(setSession(response.data.data.session));
        handleGoShippingInfo();
        localStorage.setItem(UserDeadline, new Date().getTime() + response.data.data.timeForUser * 60 * 1000);
        Socket.emit("setOpenOrderInfo", { openTxid: response.data.data.txid });
        localStorage.setItem(OpenTxid, response.data.data.txid);
        localStorage.removeItem(PaymentTxid);
      } else {
        showToastError({title: 'Error', body: response.data.message});
        handleGoQuiz();
      }
    } catch {}
  }

  useEffect(() => {

    const intervalId = setInterval(() => {
      RetryCreateContract();
    }, 15000);

    return () => clearInterval(intervalId);
  }, [walletAddress])

  return (
    <section className='page-container'>
      <div className='order-page queue-stage'>
        <div className='center-items-horizontal'>
          <PageHeader currentStepNumber={100}/>

          <div className='queue-content'>
            <h5>Sit tight. You are in line.<br/> You are in queue for the mint.</h5>
            <p>You will automatically go to info section once it’s your turn.</p>
            <WarningInformation information='Do not refresh your browser. This could make you lose your place.'/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QueuePage;